export class DateRangeParam {
    RangeValue: string;
    RangeNumber: number;
};


// WEBPACK FOOTER //
// ./src/app/models/DateRangeParam.ts